import React from 'react'
//"The Best Way To Predict The Future Is To Create It."

function Quote() {
  return (
    <section className='min-h-[146px] bg-secondary flex items-center'>
      <div
        className='container mx-auto flex md:justify-center items-center flex-wrap justify-evenly'>
        <h1 className='text-center text-[35px] italic leading-loose'>"The best way to predict the future is to create it"</h1>
      </div>
    </section>
  )
}

export default Quote